import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/shared/services/alert.service';

@Component({
  selector: 'app-sidemenu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SidemenuComponent implements OnInit {

  constructor(
    public alert: AlertService
  ) { }

  ngOnInit() {
  }

}
